import { useAppSelector } from '@/shared/hooks/useStore';
import { selectIsInternalUser } from '@/viewmodel/features/user/state/userSlice';

export function useIsStaffViewModel(): boolean {
  return useAppSelector(selectIsInternalUser);
}
